import { render } from "./Articles.vue?vue&type=template&id=5884ce88&lang=pug"
import script from "./Articles.vue?vue&type=script&lang=ts"
export * from "./Articles.vue?vue&type=script&lang=ts"

import "./Articles.vue?vue&type=style&index=0&id=5884ce88&lang=scss"
script.render = render

export default script